export default __webpack_public_path__ + "static/media/HotSeptember60s.df780a2a.mp3";